export default "__VITE_ASSET__JUYzbMAy__"